import { entity, persistence } from "simpler-state"

/** Grouping options that can be persisted across sessions */
export interface AutoSplitPreferences {
  splitByRetailer: boolean
  splitByProductLine: boolean
  splitByExecutionDate: boolean
  splitByAdminFee: boolean
}

/** Full options including per-deduction settings like reason code */
export interface AutoSplitOptions extends AutoSplitPreferences {
  reasonCodeId?: string
  reasonCodeName?: string
  /** Applied to every generated split when org field is active */
  defaultRetailerInvoiceNumber?: string
  /** Optional promotion chosen in the auto-split modal (same matching UI as split lines); applies to every generated split when org field is active */
  defaultPromotionId?: string
}

const DEFAULT_PREFERENCES: AutoSplitPreferences = {
  splitByRetailer: true,
  splitByProductLine: false,
  splitByExecutionDate: false,
  splitByAdminFee: false,
}

// Per-user preferences map: { [userKey]: AutoSplitPreferences }
export const AutoSplitPreferencesState = entity<Record<string, AutoSplitPreferences>>(
  {},
  [persistence("auto_split_preferences")]
)

export function getUserAutoSplitPreferences(userKey: string): AutoSplitPreferences | null {
  const prefs = AutoSplitPreferencesState.get()
  return prefs[userKey] ?? null
}

export function setUserAutoSplitPreferences(userKey: string, preferences: AutoSplitPreferences): void {
  AutoSplitPreferencesState.set((prev) => ({
    ...prev,
    [userKey]: preferences,
  }))
}

export function getDefaultPreferences(): AutoSplitPreferences {
  return { ...DEFAULT_PREFERENCES }
}
